import { IAppointment } from '../../hooks/promises/getAppointments';
import { getAttendanceStatus } from '../../pages/RegisterAppointment/helpers';
import AppointmentOverview from '../AppointmentOverview/AppointmentOverview';

interface IAppointmentViewWrapperProps {
  appointment: IAppointment;
}

function AppointmentViewWrapper({ appointment }: IAppointmentViewWrapperProps) {
  const attendanceStatus = getAttendanceStatus(
    appointment.didNotAttendFlag,
    appointment.lateCancellationFlag
  );
  return (
    <AppointmentOverview
      fcpName={`${appointment.user.forename} ${appointment.user.surname}`}
      attendanceStatus={attendanceStatus}
      dateOfConsultation={new Date(appointment.consultationDate)}
      doubleAppointment={appointment.doubleAppointmentFlag}
      organisation={appointment.organisation.organisationDescription}
      pcnName={
        appointment.organisation.primaryCareNetwork.organisationDescription
      }
      icsCcgName={
        appointment.organisation.clinicalCommissioningGroup
          .organisationDescription
      }
      referralSource={appointment.referralSourceDescription}
      modeOfContact={appointment.modeOfContactDescription}
      consultationType={appointment.consultationTypeDescription}
      consultationOutcomes={appointment.appointmentConsultationOutcomeList.map(
        (x) => {
          if (
            x.consultationOutcomeId ===
            Number(process.env.REACT_APP_OUTCOME_OTHER_BOX_ID)
          )
            return x.otherText;

          if (x.subOutcome)
            return `${x.subOutcome?.consultationSubOutcomeDescription} (${x.consultationOutcomeDescription})`;

          return x.consultationOutcomeDescription;
        }
      )}
      followUpMethod={appointment.followUpMethodDescription}
      followUpReason={appointment.followUpReasonDescription}
      showFollowUpInfo={appointment.consultationTypeId > 1}
      patientAgeRange={appointment.patientAgeRangeDescription}
      doubleAppointmentReason={
        appointment.doubleAppointmentFlag
          ? appointment.doubleAppointmentReasonDescription
          : ''
      }
      interpreterRequired={appointment.interpreterRequiredFlag}
    />
  );
}

export default AppointmentViewWrapper;
